import axios from "axios";
import router from "@/router";
import { getToken } from "@/utils/auth";
import { Message } from "element-ui";
const config = {
  proxy: process.env.VUE_APP_URL, // 环境变量获取地址
  // proxy: "http://192.168.3.159:9080",
};
// axios基本配置
const api = axios.create();
// 请求开始拦截
api.interceptors.request.use(
  (conf) => {
    return conf;
  },
  (error) => ({
    status: 0,
    msg: error.message,
  })
);
// 请求返回拦截
api.interceptors.response.use(
  (response) => {
    return Promise.resolve(response).then(checkCode);
  },
  () => {
    Message.warning({
      message: "系统出错了哦～",
      customClass: "zZindex",
    });
    router.push("/");
    return;
  }
);
// 后台自定义 code错误处理
const checkCode = (res) => {
  if (res?.config?.headers?.isExportType) {
    return res.data;
  }
  if (res.data.code == 200) {
    const returnData = {
      code: 200,
      success: true,
      data: res.data.data,
      msg: res.data.msg,
    };
    return returnData;
  } else {
    //统一处理错误
    if (res.data.code == 403) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = process.env.VUE_APP_FATHER;
      return false;
    }

    if (res.data.code == 406) {
      sessionStorage.clear();
      window.location.href = process.env.VUE_APP_FATHER;
      Message.warning({
        message: "登录已过期,请重新登录",
        customClass: "zZindex",
      });
    } else {
      Message.warning({
        message: res.data.msg || "网络出小差了",
        customClass: "zZindex",
      });
    }
    if (res.data.code == 401) {
      router.push("/");
    }
    return false;
  }
};

// 解析参数
const formatParams = (method = "GET", params, type, timeout) => {
  let contentType = "";
  let isExportType = false;
  let responseType = "";
  //headers配置token
  if (type == "file") {
    //文件配置
    contentType = "multipart/form-data";
  } else if (type == "exportFile") {
    contentType = "application/json";
    isExportType = true;
    responseType = "blob";
  } else {
    //普通接口配置
    contentType = "application/json";
  }
  let headers = {
    "Content-Type": contentType,
    Authorization: getToken() ? getToken() : "",
    appId: process.env.VUE_APP_APPID,
    isExportType,
  };
  switch (method) {
    case "POST":
    case "PUT":
    case "DELETE":
      return {
        timeout: timeout ? timeout : 30000,
        headers,
        method,
        data: params,
        responseType,
      };
    case "GET":
      return {
        timeout: 30000,
        headers,
        method,
      };
  }
};

export { api, formatParams, config };
